// Librerias
import { createContext, useState } from "react";
import { useLocation } from "react-router-dom";

// Otros
import useUrlParams from "../hooks/useUrlParams";

/**
 * Descripcion del context: La descripción de por qué estamos haciendo este context y que resuelve.
 *
 * Implementacion: Descripción sobre cómo puedes implementar el context.
 *
 * Bugs: Qué bugs se han presentado y como se solucionan.
 */

const FiltersContext = createContext();

export function FiltersProvider({ children }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [filters, setFilters] = useState({
    event: query.get("event") || "",
    country: query.get("country") || "",
  });

  useUrlParams(filters);

  return (
    <FiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </FiltersContext.Provider>
  );
}
export default FiltersContext;
